export const HOUR_WIDTH = 80;
export const HOUR_HEIGHT = 40;
export const HOURS = 54;
export const START_HOUR = 17;


// WEBPACK FOOTER //
// ./src/components/Schedule/ScheduleComponent/helpers/constants.js